import React, { Component } from "react";
import { connect } from "react-redux";
import gql from "graphql-tag";

import { Query, Mutation } from "react-apollo";
import { Box } from "reflexbox";
import { Modal } from "office-ui-fabric-react/lib/Modal";

import FileUploader from "../../common/_FileUploader";


import {
  DetailsList,
  SelectionMode
} from "office-ui-fabric-react/lib/DetailsList";

import { toast } from "react-toastify";
import { ActionButton, IconButton } from "office-ui-fabric-react/lib/Button";
import { dismissShipmentAttachment } from "../../actions/ui_actions";

class ShipmentAttachmentsDialog extends Component {
  render() {
    return (
      <div>
        <Modal isOpen={this.props.visible} onDismiss={this.props.dismiss}>
          <Box
            flex
            align="center"
            justify="space-between"
            style={{ minHeight: "50px", background: "#bddded" }}
          >
            <Box style={{ fontSize: "large" }} pl={2}>
              Shipment files
            </Box>
            <Box pr={1}>
              <ActionButton
                iconProps={{ iconName: "ChromeClose" }}
                onClick={this.props.dismiss}
              />
            </Box>
          </Box>
          <Box wrap m={2}>
            <Box style={{ width: "50vw" }}>
              <Query
                query={SHIPMENT_STORAGE}
                variables={{ id: this.props.shipment.id }}
                skip={!this.props.shipment.id}
              >
                {({ loading, error, data }) => {
                  if (loading) return <p>Loading...</p>;
                  if (error) return <p>Error :(</p>;

                  return (
                    <div>
                      <DetailsList
                        items={data.allStorages.nodes}
                        setKey="key"
                        compact
                        selectionMode={SelectionMode.none}
                        columns={[
                          {
                            key: "filename",
                            name: "File name ",
                            fieldName: "fileName",
                            minWidth: 100,
                            maxWidth: 150,
                            onRender: item => {
                              return (
                                <a href={item.url} target="_blank">
                                  {item.fileName}
                                </a>
                              );
                            }
                          },
                          {
                            key: "delete",
                            name: "Delete",
                            fieldName: "Delete",
                            minWidth: 50,
                            maxWidth: 100,
                            onRender: item => {
                              return (
                                <Mutation
                                  mutation={DELETE_STORAGE}
                                  refetchQueries={[
                                    "ShipmentFiles",
                                    "allShipments"
                                  ]}
                                >
                                  {(mutate, { data }) => (
                                    <IconButton
                                      onClick={e => {
                                        e.preventDefault();
                                        mutate({
                                          variables: { id: item.id }
                                        });
                                      }}
                                      iconProps={{ iconName: "Delete" }}
                                      title="Delete file"
                                    />
                                  )}
                                </Mutation>
                              );
                            }
                          }
                        ]}
                      />
                    </div>
                  );
                }}
              </Query>
            </Box>
            <Box mt={3}>
              <Mutation
                mutation={CREATE_STORAGE}
                refetchQueries={["ShipmentFiles", "allShipments"]}
              >
                {(createStorage, { loading, error, success }) => (
                  <FileUploader
                    handleFinishUpload={(res,  file) => {
                      const shipmentId = this.props.shipment.id;

                      const { name, type, size } = file;
                      // TODO move to .env
                      const fileUrl = 'https://apiv1.colourrush.nl' + res.publicUrl;

                      createStorage({
                        variables: {
                          name,
                          type,
                          size,
                          fileUrl,
                          shipmentId
                        }
                      })
                        .then(response => {
                          toast.success(`Uploaded !`);
                        })
                        .catch(err => {
                          toast.error(`${err}`);
                        });
                    }}
                  />
                )}
              </Mutation>
            </Box>
          </Box>
        </Modal>
      </div>
    );
  }
}

export const CREATE_STORAGE = gql`
  mutation(
    $name: String!
    $size: Int!
    $type: String!
    $fileUrl: String!
    $orderId: Int
    $relationId: Int
    $carrierId: Int
    $shipmentId: Int
    $contactId: Int
  ) {
    createStorage(
      input: {
        storage: {
          fileName: $name
          fileSize: $size
          fileType: $type
          url: $fileUrl
          orderId: $orderId
          relationId: $relationId
          carrierId: $carrierId
          shipmentId: $shipmentId
          contactId: $contactId
        }
      }
    ) {
      storage {
        id
        fileName
        fileSize
        fileType
        url
        orderId
        relationId
        carrierId
        shipmentId
        contactId
      }
    }
  }
`;

export const DELETE_STORAGE = gql`
  mutation deleteStorageById($id: Int!) {
    deleteStorageById(input: { id: $id }) {
      storage {
        id
        fileName
        fileSize
        fileType
        url
        orderId
        relationId
        carrierId
        shipmentId
        contactId
      }
    }
  }
`;

export const SHIPMENT_STORAGE = gql`
  query ShipmentFiles($id: Int) {
    allStorages(condition: { shipmentId: $id }) {
      nodes {
        id
        fileName
        fileSize
        fileType
        url
      }
    }
  }
`;

const mapStateToProps = state => {
  return {
    visible: state.ui.shipmentAttachment,
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  dismiss: dismissShipmentAttachment
})(ShipmentAttachmentsDialog);



// WEBPACK FOOTER //
// ./src/common/Forms/_ShipmentAttachmentsDialog.js